<template>
  <div class="baogao-detail">
    <div class="baogao-detail-top">
      <img src="~@/assets/images/zhuyuan/zy-jy-bj.png" alt="">
    </div>
    <!-- <table class="table">
      <tr class="bor">
        <th></th>
        <th>检验项目</th>
        <th>结果</th>
        <th>参考值</th>
        <th>单位</th>
      </tr>
      <tr v-for="item in list" :key="item.id">
        <td>{{item.itemCode}}</td>
        <td>{{item.itemName}}</td>
        <td>{{item.currentResult}}</td>
        <td>{{item.ranges}}</td>
        <td>{{item.unit}}</td>
      </tr>
    </table> -->
    <van-cell-group class="centre" inset>
      <van-cell title="开方医生">
        <template #default>
          {{ info.reqDoc }}
        </template>
      </van-cell>
      <van-cell title="开方科室">
        <template #default>
          {{ info.reqDept }}
        </template>
      </van-cell>
      <van-cell title="报告时间">
        <template #default>
          {{ info.reqDate }}
        </template>
      </van-cell>
      <van-cell title="报告单号">
        <template #default>
          {{ info.barcode }}
        </template>
      </van-cell>
    </van-cell-group>
    <div class="list-box">
      <div class="list-wrap">
        <div class="list-item" />
        <div class="list-item">检验项目</div>
        <div class="list-item">结果</div>
        <div class="list-item">参考值</div>
        <div class="list-item">单位</div>
      </div>
      <div v-for="item in list" :key="item.id" class="list-wrap list-wrap2">
        <div class="list-item">{{ item.testId }}</div>
        <div class="list-item">{{ item.testName }}</div>
        <div class="list-item">{{ item.result }}</div>
        <div class="list-item">{{ item.referenceValue }}</div>
        <div class="list-item">{{ item.unit }}</div>
      </div>
      <van-button round type="info" class="download-btn" @click="downloadEvn">下载报告</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaoGaoDetail',
  data() {
    return {
      info: {},
      list: [],
      patientName: '',
      reportNo: ''
    }
  },
  created() {
    this.patientName = this.$route.query.patientName
    this.reportNo = this.$route.query.reportNo
    const baogaoDetail = localStorage.getItem('baogaoDetail')
    this.getReportDetail()
    if (!baogaoDetail) return
    this.info = JSON.parse(baogaoDetail)
  },
  mounted() {},
  methods: {
    getReportDetail() {
      this.$Apis.getReportDetail({ patientName: this.patientName, reportNo: this.reportNo }).then(res => {
        this.list = res.data.reports || []
      })
    },
    downloadEvn() {
      this.$Apis.msGetPdf({ sampleNo: this.$route.query.reportNo }).then(res => {
        if (res.code === 200) {
          const base64Data = res.data.content // 假设接口返回的是纯Base64字符串
          const mimeType = 'image/jpg' // 根据实际格式调整
          const filename = `报告_${this.reportNo}.pdf`
          this.downloadBase64File(base64Data, filename, mimeType)
        }
      })
    },
    downloadBase64File(base64Data, filename, mimeType) {
      const byteCharacters = atob(base64Data)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], { type: mimeType })
      const url = window.URL.createObjectURL(blob)

      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
.download-btn{
  width: 100%;
  margin-top: 15px;
}
.baogao-detail{
  overflow: hidden;
  min-height: 100vh;
  .baogao-detail-top{
    padding: .1rem .15rem 0;
    min-height: 1.25rem;
    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
  .centre{
    margin: .1rem .15rem;
  }
  .list-box{
    margin: .1rem .15rem;
    padding: .1rem;
    background: #fff;
    border-radius: .1rem;
  }
  .list-wrap{
    display: flex;
    border-top: 1px solid #E8EAED;
    border-bottom: 1px solid #E8EAED;
    .list-item{
      color: #2B8CFF;
      background: #F8F8F8;
      flex: 1;
      word-break: break-all;
      // white-space:nowrap;
      padding: .1rem .05rem;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1.5;
      border-left: 1px solid #E8EAED;
    }
    :last-child{
      border-right: 1px solid #E8EAED;
    }
  }
  .list-wrap2{
    border-top: none;
    .list-item{
      color: #555;
      background: #fff;
    }
  }
  .table{
    padding: 0 .15rem;
    background: #fff;
    width: 100%;
    tr{
      border-bottom: 1px solid #ccc;
    }
    th{
      line-height: .3rem;
      font-size: .14rem;
    }
    td{
      line-height: .3rem;
      font-size: .12rem;
    }
  }
}
</style>
